module.exports = __webpack_public_path__ + "media/tr_tr_s1_Ahmet.f52af3dc.oga";